import React, { useState } from 'react';
import { XIcon, ChevronDownIcon, ChevronUpIcon, CopyIcon, CheckIcon } from 'lucide-react';
export function ErrorPopup({
  isOpen,
  onClose,
  errorMessage,
  debugInfo
}) {
  const [showDebug, setShowDebug] = useState(false);
  const [copied, setCopied] = useState(false);
  if (!isOpen) return null;
  const handleCopyToClipboard = () => {
    const debugText = `Error Message:\n${errorMessage}\n\nDebug Information:\n${JSON.stringify(debugInfo, null, 2)}`;
    navigator.clipboard.writeText(debugText);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };
  return <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4" data-id="element-80">
      <div className="bg-white rounded-lg shadow-2xl max-w-2xl w-full max-h-[90vh] overflow-hidden flex flex-col" data-id="element-81">
        <div className="bg-red-600 text-white p-4 flex justify-between items-center" data-id="element-82">
          <h2 className="text-xl font-bold" data-id="element-83">Error Submitting Quote</h2>
          <button onClick={onClose} className="hover:bg-red-700 rounded-full p-1 transition-colors" data-id="element-84">
            <XIcon className="w-6 h-6" data-id="element-85" />
          </button>
        </div>
        <div className="p-6 overflow-y-auto flex-1" data-id="element-86">
          <div className="mb-6" data-id="element-87">
            <p className="text-gray-800 text-lg" data-id="element-88">
              An error occurred while submitting your quote. Please try again.
            </p>
            <p className="text-gray-600 text-sm mt-2" data-id="element-89">
              If the problem persists, please contact support with the debug
              information below.
            </p>
          </div>
          <button onClick={() => setShowDebug(!showDebug)} className="flex items-center text-blue-600 hover:text-blue-700 font-medium mb-4" data-id="element-90">
            {showDebug ? <>
                <ChevronUpIcon className="w-5 h-5 mr-1" data-id="element-91" />
                Hide debug info
              </> : <>
                <ChevronDownIcon className="w-5 h-5 mr-1" data-id="element-92" />
                Show debug info
              </>}
          </button>
          {showDebug && <div className="bg-gray-50 rounded-lg p-4 border border-gray-200" data-id="element-93">
              <div className="flex justify-between items-center mb-3" data-id="element-94">
                <h3 className="font-semibold text-gray-800" data-id="element-95">
                  Debug Information
                </h3>
                <button onClick={handleCopyToClipboard} className="flex items-center text-sm text-blue-600 hover:text-blue-700 font-medium" data-id="element-96">
                  {copied ? <>
                      <CheckIcon className="w-4 h-4 mr-1" data-id="element-97" />
                      Copied!
                    </> : <>
                      <CopyIcon className="w-4 h-4 mr-1" data-id="element-98" />
                      Copy to clipboard
                    </>}
                </button>
              </div>
              <div className="mb-4" data-id="element-99">
                <h4 className="font-medium text-gray-700 mb-2" data-id="element-100">
                  Error Message:
                </h4>
                <div className="bg-white p-3 rounded border border-red-200 text-sm text-red-700 font-mono" data-id="element-101">
                  {errorMessage}
                </div>
              </div>
              <div data-id="element-102">
                <h4 className="font-medium text-gray-700 mb-2" data-id="element-103">
                  Request Parameters:
                </h4>
                <pre className="bg-white p-3 rounded border border-gray-300 text-xs overflow-x-auto" data-id="element-104">
                  {JSON.stringify(debugInfo, null, 2)}
                </pre>
              </div>
            </div>}
        </div>
        <div className="border-t border-gray-200 p-4 bg-gray-50" data-id="element-105">
          <button onClick={onClose} className="w-full bg-blue-600 text-white px-6 py-3 rounded-md font-bold hover:bg-blue-700 transition-colors" data-id="element-106">
            Close
          </button>
        </div>
      </div>
    </div>;
}